import InputField from '@/ui/components/Form/InputField';

import { Props } from './types';
/**
 * @deprecated Do not use this component. There is no equivalent yet at the root
 * of the UI folder — a new version should be built there using the current
 * design-system patterns (tailwind-variants + Headless UI, see src/ui/Button)
 * instead of using this legacy component.
 */
const SSNInput = ({ id = 'ssn', onChange, value }: Props) => {
  return (
    <InputField
      autoComplete="off"
      id={id}
      label="Social Security Number"
      helpText="Ex. 555 11 0000"
      inputMode="numeric"
      maxLength={11}
      onChange={onChange}
      placeholder="___ __ ____"
      type="text"
      value={value}
    />
  );
};

export default SSNInput;
